import { render, staticRenderFns } from "./ModuleDialog.vue?vue&type=template&id=272d217c"
import script from "./ModuleDialog.vue?vue&type=script&lang=js"
export * from "./ModuleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports